import React, {useEffect} from 'react'
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import { useDispatch, useSelector } from 'react-redux';
import Spinner from "react-bootstrap/Spinner";
import FormBirthday from 'components/Form/FormBirthday'
import * as Yup from 'yup'
import moment from 'moment'
import "pages/userInformation.scss";
// import { values } from 'analytics/lib/analytics.cjs';

function UserInformationForm(props) {

    const { user } = props;
    const { handleFormSubmission } = props;

    const { register, control, handleSubmit, setValue, getValues, formState, reset, errors } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            firstName: Yup.string().required('This field is required'),
            lastName: Yup.string().required('This field is required'),
            email: Yup.string().email("Please enter a valid email address").required('This field is required')
        }),
        defaultValues: {
            firstName: user.firstName ?? "",
            lastName: user.lastName ?? "",
            email: user.email ?? "",
            phone: user.phone ?? "",
            birthday: user.birthday ?? "",
            gender: user.gender ?? "Prefer not to say",
            region: user.region ?? "",
            injuries: user.injuries ?? ""
          }
    });
    const { dirty } = formState;
    
    const onSubmit = (data) => {
        if (!data.birthday) {
            delete data.birthday
        }
        if (handleFormSubmission) {
            handleFormSubmission(data)
        }
    }
    const cities = ["Toronto", "New York","Los Angeles","Melbourne", "Paris", "London", "Ireland", "Boulder", "Halifax", "Cape Cod", "Salem", "North Carolina", "Chicago","Quito, Ecuador", "Regina, Saskatchewan","Houston","Phoenix","Philadelphia","San Antonio","San Diego","Dallas","San Jose","Austin","Fort Worth","Jacksonville","Columbus","Charlotte","San Francisco","Indianapolis","Seattle","Denver","Washington","Boston","El Paso","Nashville","Detroit","Portland","Las Vegas","Oklahoma City","Memphis","Louisville","Baltimore","Milwaukee","Albuquerque","Tucson","Fresno","Mesa","Atlanta","Sacramento","Kansas City","Miami","Colorado Springs","Raleigh","Omaha","Long Beach","Virginia Beach","Minneapolis","Oakland","Tampa","Arlington","Tulsa","Bakersfield","New Orleans","Wichita","Aurora","Cleveland","Anaheim","Honolulu","Riverside","San Juan Zona Urbana","Santa Ana","Henderson","Lexington","Corpus Christi","Stockton","St. Paul","Cincinnati","Irvine","Greensboro","Pittsburgh","Lincoln","St. Louis","Orlando","Plano","Anchorage","Newark","Durham","Chula Vista","St. Petersburg","Jersey City","Fort Wayne","Toledo","Chandler","Laredo","Madison","Scottsdale","Lubbock","Reno","Gilbert","Buffalo","Glendale","North Las Vegas","Winston Salem","Chesapeake","Garland","Irving","Hialeah","Norfolk","Fremont","Boise","Paradise","Richmond", "Monterey"]
    const cityOptions = cities.map(val => {return {value: val, label: val}})

    const genders = ["Female", "Male", "Non-binary/genderqueer", "I prefer to self-identify", "Prefer not to say"]
    const genderOptions = genders.map(val => {return {value: val, label: val}})

    useEffect(() => {
        register({ name: 'avatarImage'})
        register({ name: 'birthday' })
    }, [register])

    const birthMonth = () => {
        const bday = getValues().birthday
        if (!bday || bday.split("-").length !== 3) {
            return ""
        }
        return moment(bday).format("MMMM")
    }

    return (
    <form className={"userInformationForm" } onSubmit={handleSubmit(onSubmit)} noValidate={true}>
        {/* {errors && (
            + " " + (Object.keys(errors).length > 0 ? "was-validated" : "needs-validation")
            <div>
                {JSON.stringify(errors)}
            </div>
        )} */}
        <section>
            <div className="row">
                <div className="col-sm-10">
                    <h2>My account settings</h2>
                </div>
                <div className="col-sm-2">
                    <button disabled={!dirty} type="submit" className="btn btn-primary primaryColor">
                        
                        <span>{"Save changes"}</span>

                        {props.isSaving && (
                            <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                            >
                            <span className="sr-only">Saving...</span>
                            </Spinner>
                        )}
                    </button>
                </div>
            </div>
        </section>

        <section>
            <FormImage
            fullSize
            imageUrl={user.profileImageUrl}
            name="avatarImage"
            label="Profile photo"
            defaultName={user.firstName}
            sublabel={"(Square image recommended)"}
            register={register}
            fileSelection={(file) => {setValue('avatarImage', file)}}
            />

            <FormGroup
            fullSize
            type="text"
            name="firstName"
            label="First name"
            placeholder="Your first name"
            register={register}
            error={errors.firstName}
            />

            <FormGroup
            fullSize
            type="text"
            name="lastName"
            label="Last name"
            placeholder="Your last name"
            // register={register({required: true, maxLength: 100})}
            register={register}
            error={errors.lastName}
            />  

            <FormGroup
            fullSize
            type="email"
            name="email"
            label="Email"
            placeholder="Your email address"
            register={register}
            error={errors.email}
            /> 

            <FormGroup
            fullSize
            type="tel"
            name="phone"
            label="Phone"
            pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
            placeholder="Your phone number"
            register={register}
            />

            <FormBirthday 
            fullSize
            label="Birthday"
            birthday={user.birthday}
            onChange={(val) => {
                console.log(val)
                setValue('birthday', val)
            }}
            />

            <FormGroup 
            fullSize
            select
            options={genderOptions}
            type="select"
            name="gender"
            label="Gender"
            small
            placeholder="Select one"
            control={control}
            setValue={setValue}
            getValues={getValues}
            />

            
        </section>

        <section>
            <div className="row">
                <div className="col-sm-12">
                    <div className="d-flex d-row">
                        <h4 className="pt-1 m-0 text-nowrap">About me -&nbsp;</h4>
                        <p className="m-0 pt-1">Share more about yourself so your instructor can provide special shoutouts and learn about you before taking a class</p>
                    </div>
                </div>

            </div>
        </section>

        <section>

            <FormGroup 
            fullSize
            select
            options={cityOptions}
            type="multiselect"
            name="region"
            label="Region"
            sublabel="Where you are"
            placeholder="Select a city"
            control={control}
            setValue={setValue}
            getValues={getValues}
            />

            <FormGroup
            fullSize
            type="text"
            name="birthdayMonth"
            label="Birthday month"
            placeholder={birthMonth()}
            disabled
            />

            <FormGroup
            fullSize
            textarea
            name="injuries"
            label="Injuries"
            placeholder="None"
            register={register}
            control={control}
            setValue={setValue}
            getValues={getValues}
            />
        </section>
        <div className="row">
            <div className="col-sm-12 d-flex justify-content-end">
                <button disabled={!dirty} type="submit" className="btn btn-primary primaryColor">Save changes</button>
            </div>
        </div>
        

    </form>
    )
}

export default UserInformationForm;